import { type ServiceMethod } from '@/application/interfaces/service';

import adapter from './adapter';
import { type ExternalResponse, type Response } from './model';

export type SearchParams = {
  appId: string;
};

export type Body = {
  card: {
    number: string;
    holder_name: string;
    cvv: string;
    exp_month: string;
    exp_year: string;
  };
  type: 'card';
};

const baseUrl = process.env.NEXT_PUBLIC_PAGARME_BASE_URL;
const appId = process.env.NEXT_PUBLIC_PAGARME_APP_ID;

const postPagarmeCheckCard: ServiceMethod<Response, Body> =
  (httpClient) => async (data, options) => {
    const { card, type } = data;

    const { body: response, status } = await httpClient.post<
      ExternalResponse,
      Body,
      undefined,
      SearchParams
    >('/core/v5/tokens', {
      ...options,
      body: { card, type },
      searchParams: {
        appId,
      },
      baseUrl,
    });

    if (status < 200) {
      throw new Error('pagarme api failed');
    }

    return adapter(response);
  };

export default postPagarmeCheckCard;
